/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {AppSharedModule} from '../../app-shared.module';
import {AdnSelectComponent} from '../adn-select/adn-select.component';
import {AdnChecklistComponent} from './checklist.component';
import {CurrencyFormControlComponent} from './currency-form-control.component';
import {DateTimePickerComponent} from './date-time-picker.component';
import {FormButtonsStickyDirective} from './form-buttons-sticky.directive';
import {HttpPrefixerDirective} from './http-prefixer.directive';
import {HttpsPrefixerDirective} from './https-prefixer.directive';
import {IabMultiSelectComponent} from './iab-multi-select.component';
import {IntegerValidationDirective} from './integer-validation.directive';
import {ResourceLabelsComponent} from './labels-component';
import {MoneyFieldComponent} from './money-field.component';
import {MoneySpacerDirective} from './money-spacer.directive';
import {TagsInputComponent} from './tags-input.component';
import {MessageDismisserComponent} from './message-dismisser.component';

const FORM_CONTROLS = [
  DateTimePickerComponent,
  AdnChecklistComponent,
  CurrencyFormControlComponent,
  MoneyFieldComponent,
  MoneySpacerDirective,
  TagsInputComponent,
  ResourceLabelsComponent,
  IabMultiSelectComponent,
  HttpPrefixerDirective,
  HttpsPrefixerDirective,
  IntegerValidationDirective,
  FormButtonsStickyDirective,
  MessageDismisserComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    NgSelectModule,
    AdnSelectComponent,
    BsDatepickerModule,
    TimepickerModule
  ],
  declarations: FORM_CONTROLS,
  exports: FORM_CONTROLS
})
export class FormControlsModule {
}
